import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesFailed, EGetAuthorArticlesActionType } from './types';

export const getAuthorArticlesFailed: () => TGetAuthorArticlesFailed =
  actionGenerator<EGetAuthorArticlesActionType.Failed>(EGetAuthorArticlesActionType.Failed);
